"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeValidator = void 0;
const results_1 = require("./results");
function makeValidator({ predicate, message }) {
    return (value, form, label) => (predicate(value, form)
        ? (0, results_1.valid)()
        : (0, results_1.invalid)(message.replace(':label', label || 'Field')));
}
exports.makeValidator = makeValidator;
